/******************************************************************************
 * @Author                : Hamza Damene                                      *
 * @CreatedDate           : 2025-03-19 15:00:00                               *
 * @LastEditors           : Hamza Damene                                      *
 * @LastEditDate          : 2025-03-19 15:00:00                               *
 *****************************************************************************/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { useWorkorderInformation } from "../../../../../hooks/useWorkorderInformation";
import { t } from "i18next";

/**
 * Props pour le composant ScheduleSection
 */
interface ScheduleSectionProps {
  workorder: EasyTech.Workorder;
  informationHook: ReturnType<typeof useWorkorderInformation>;
}

/**
 * Section de planification du workorder
 * @param workorder - Données du workorder
 * @param informationHook - Hook contenant la logique d'édition
 * @returns Composant React pour la section de planification
 */
export function ScheduleSection({ workorder, informationHook }: ScheduleSectionProps) {
  const {
    formData,
    isEditing,
    formatDuration,
    calculateDuration
  } = informationHook;

  const getDuration = () => {
    if (isEditing && formData.schedule.start && formData.schedule.end) {
      return calculateDuration(formData.schedule.start, formData.schedule.end);
    }
    const workorderDuration = workorder?.schedule?.duration || 0;
    const durationInMinutes = workorderDuration > 10000 ? Math.round(workorderDuration / (1000 * 60)) : workorderDuration;
    return durationInMinutes;
  };

  return (
    <>
      <div className="field">
        <Typography variant="small" >{t("common:scheduleStart")}</Typography>
        <Typography>
          {workorder?.schedule?.start ? new Date(workorder.schedule.start).toLocaleString() : "-"}
        </Typography>
      </div>
      <div className="field">
        <Typography variant="small" >{t("common:scheduleEnd")}</Typography>
        <Typography>
          {workorder?.schedule?.end ? new Date(workorder.schedule.end).toLocaleString() : "-"}
        </Typography>
      </div>
      {workorder?.schedule?.start && workorder?.schedule?.end && (
        <div className="field col-span-2 mt-2">
          <Typography variant="small" >{t("common:scheduleDuration")}</Typography>
          <Typography>
            {formatDuration(Number(getDuration()))}
          </Typography>
        </div>
      )}
    </>
  );
} 